// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useAuth } from "../../auth/AuthContext";
// import {
//   Button,
//   Card,
//   CardHeader,
//   CardBody,
//   FormGroup,
//   Form,
//   Input,
//   Container,
//   Row,
//   Col,
//   ModalFooter,
//   Label,
//   Table,
// } from "reactstrap";
// import Swal from "sweetalert2";
// import Header from "components/Headers/Header";
// import { useSessionStore } from "../../stores/sessionStore";
// import { api } from "../../config/middleware";
// import { API_CREATEBILL, API_GETSERVICEWITHPRODUCTS } from "../../config/api";

// const AddRecordOrder = () => {
//   const sa = {
//     info: (text, title = "แจ้งเตือน") =>
//       Swal.fire({ icon: "info", title, text, confirmButtonText: "ตกลง" }),
//     success: (text, title = "สำเร็จ") =>
//       Swal.fire({ icon: "success", title, text, confirmButtonText: "ตกลง" }),
//     error: (text, title = "เกิดข้อผิดพลาด") =>
//       Swal.fire({ icon: "error", title, text, confirmButtonText: "ปิด" }),
//   };

//   const navigate = useNavigate();
//   const location = useLocation();
//   const { user } = useAuth();
//   const role = (
//     user?.role ||
//     localStorage.getItem("role") ||
//     "user"
//   ).toLowerCase();

//   const orgId = useSessionStore((s) => s.profile?.orgId);
//   const tnId = useSessionStore((s) => s.profile?.tnId);
//   const brId = useSessionStore((s) => s.profile?.brId);

//   // ฟอร์มหลัก
//   const [form, setForm] = useState({
//     serviceId: "",
//     customerCode: "",
//     customerName: "",
//   });

//   // วันที่
//   const [receiveDate, setReceiveDate] = useState(""); // BRECEIVE
//   const [dueDate, setDueDate] = useState(""); // BDUEDATE

//   // สินค้า/ตัวเลือก (จะถูกแทนด้วยข้อมูลจากแพ็กเกจ ถ้ามี)
//   const [cusTypeOptions, setCusTypeOptions] = useState([]);

//   const [serviceOptions, setServiceOptions] = useState([]);

//   // รายการย่อย
//   const [detailName, setDetailName] = useState("");
//   const [detailQty, setDetailQty] = useState("");
//   const [detailPrice, setDetailPrice] = useState("");
//   const [details, setDetails] = useState([]);

//   const OrderBillState = location?.state || {};
//   const selectedPkg = OrderBillState.package || null;

//   const [serviceUnit, setServiceUnit] = useState("");
//   console.log(`serviceUnit`, serviceUnit);

//   useEffect(() => {
//     // อ่าน location.state ที่ส่งมาจากหน้าก่อนหน้า (OrderBillOrg)
//     const s = location?.state;
//     if (!s) return;

//     const selectedCustomer = s.customer;
//     const selectedPkg = s.package;

//     if (selectedCustomer) {
//       // เติมช่องลูกค้า (readOnly ที่แสดง)
//       setForm((prev) => ({
//         ...prev,
//         customerCode: selectedCustomer.code || selectedCustomer.id || "",
//         customerName: selectedCustomer.name || "",
//       }));
//     }

//     if (selectedPkg) {
//       // เติม serviceOptions ให้มีค่าเดียวจากแพ็กเกจ และ preselect serviceId
//       setServiceOptions([
//         { value: String(selectedPkg.svId), label: `${selectedPkg.name}` },
//       ]);
//       setForm((prev) => ({ ...prev, serviceId: String(selectedPkg.svId) }));

//       // สร้าง cusTypeOptions จาก products ในแพ็กเกจ (pdId, pdName, pdPrice)
//       const prods = Array.isArray(selectedPkg.products)
//         ? selectedPkg.products
//         : [];
//       const mapped = prods.map((p) => ({
//         value: String(p.pdId ?? p.pdId),
//         label: p.pdName ?? p.pdName,
//         price: Number(p.pdPrice ?? p.pdPrice ?? 0),
//       }));
//       if (mapped.length > 0) {
//         setCusTypeOptions(mapped);
//       }
//       if (selectedPkg.svUnit) {
//         setServiceUnit(selectedPkg.svUnit);
//       }
//     }
//   }, [location]);

//   useEffect(() => {
//     const fetchServiceDetail = async () => {
//       if (!orgId || !form.serviceId) return;

//       try {
//         const res = await api.get(API_GETSERVICEWITHPRODUCTS, {
//           params: { ORGID: orgId },
//         });

//         const list = Array.isArray(res?.data?.data) ? res.data.data : [];

//         // เทียบ svId กับ serviceId จาก location / form
//         const svc = list.find((s) => String(s.svId) === String(form.serviceId));

//         if (svc?.svUnit) {
//           setServiceUnit(svc.svUnit);
//         }
//       } catch (err) {
//         console.error("Fetch service unit error:", err);
//       }
//     };

//     fetchServiceDetail();
//   }, [orgId, form.serviceId]);

//   const onChange = (e) => {
//     const { name, value } = e.target;
//     setForm((s) => ({ ...s, [name]: value }));
//   };

//   // เมื่อเลือกสินค้า → เติมราคาให้อัตโนมัติ
//   const handleSelectProduct = (e) => {
//     const val = e.target.value;
//     setDetailName(val);
//     const found = cusTypeOptions.find((o) => String(o.value) === String(val));
//     if (found) setDetailPrice(Number(found.price || 0).toFixed(2));
//     else setDetailPrice("");
//   };

//   const handleAddDetail = () => {
//     const qty = Number(detailQty);
//     const price = Number(detailPrice);
//     if (!detailName) return alert("กรุณาเลือกสินค้า");
//     if (!qty || qty <= 0) return alert("กรุณากรอกจำนวนให้ถูกต้อง");
//     if (!price || price <= 0) return alert("ราคาสินค้าไม่ถูกต้อง");

//     const product = cusTypeOptions.find(
//       (o) => String(o.value) === String(detailName)
//     );
//     setDetails((prev) => [
//       ...prev,
//       {
//         id: Date.now(),
//         productValue: detailName,
//         productLabel: product?.label,
//         qty,
//         price,
//         unit: serviceUnit,
//       },
//     ]);

//     setDetailName("");
//     setDetailQty("");
//     setDetailPrice("");
//   };

//   const handleChangeDetailQty = (id, value) => {
//     const qty = Number(value);
//     setDetails((prev) =>
//       prev.map((item) =>
//         item.id === id ? { ...item, qty: isNaN(qty) ? "" : qty } : item
//       )
//     );
//   };

//   const handleRemoveDetail = (id) =>
//     setDetails((prev) => prev.filter((d) => d.id !== id));

//   const handleCancelAddRecordOrder = () => {
//     navigate("/order-orgs");
//   };

//   const handleSaveBill = async () => {
//     try {
//       // ตรวจค่าพื้นฐานก่อน
//       if (tnId == null || orgId == null || brId == null) {
//         await Swal.fire({
//           icon: "error",
//           title: "ไม่พบข้อมูลสาขาหรือองค์กร (TNID/ORGID/BRID)",
//           confirmButtonText: "ปิด",
//         });
//         return;
//       }

//       if (!form.customerCode) {
//         await Swal.fire({
//           icon: "info",
//           title: "กรุณาเลือกลูกค้า",
//           confirmButtonText: "ตกลง",
//         });
//         return;
//       }

//       if (!form.serviceId) {
//         await Swal.fire({
//           icon: "info",
//           title: "กรุณาเลือกแพ็คเกจ/บริการ",
//           confirmButtonText: "ตกลง",
//         });
//         return;
//       }

//       if (!receiveDate || !dueDate) {
//         await Swal.fire({
//           icon: "info",
//           title: "กรุณาเลือกวันที่รับผ้าและวันที่ส่งผ้า",
//           confirmButtonText: "ตกลง",
//         });
//         return;
//       }

//       if (details.length === 0) {
//         await Swal.fire({
//           icon: "info",
//           title: "กรุณาเพิ่มรายการสินค้าอย่างน้อย 1 รายการ",
//           confirmButtonText: "ตกลง",
//         });
//         return;
//       }

//       const ITEMS = details
//         .filter((d) => d.productValue)
//         .map((d) => ({
//           pdId: d.productValue,
//           bdQty: Number(d.qty || 0),
//           pdPrice: Number(d.price || 0),
//         }))
//         .filter((it) => it.bdQty > 0);

//       if (ITEMS.length === 0) {
//         await Swal.fire({
//           icon: "info",
//           title: "ไม่พบรายการสินค้าที่สามารถเปิดบิลได้",
//           confirmButtonText: "ตกลง",
//         });
//         return;
//       }

//       const payload = {
//         TNID: tnId,
//         ORGID: orgId,
//         BRID: brId,
//         CMCODE: form.customerCode,
//         SVID: form.serviceId,
//         BRECEIVE: receiveDate,
//         BDUEDATE: dueDate,
//         DISCOUNT: 0,
//         VAT: 0,
//         ITEMS,
//       };

//       const res = await api.post(API_CREATEBILL, payload);
//       const ok = res?.data?.statustext === "SUCCESS";

//       if (!ok) {
//         console.error("CreateBill error:", res?.data);
//         await Swal.fire({
//           icon: "error",
//           title: res?.data?.message || "เปิดบิลไม่สำเร็จ",
//           confirmButtonText: "ปิด",
//         });
//         return;
//       }

//       await Swal.fire({
//         icon: "success",
//         title: res?.data?.message || "เปิดบิลสำเร็จ",
//         timer: 1500,
//         showConfirmButton: false,
//       });

//       navigate("/order-bill-org");
//     } catch (e) {
//       console.error("CreateBill exception:", e);

//       await Swal.fire({
//         icon: "error",
//         title: e?.response?.data?.message || e?.message || "เกิดข้อผิดพลาด",
//         confirmButtonText: "ปิด",
//       });
//     }
//   };

//   return (
//     <>
//       <Header />
//       <Container className="mt--7" fluid>
//         <Row>
//           <Col xs="12">
//             <Card className="bg-secondary shadow">
//               <CardHeader className="bg-white border-0">
//                 <Row className="align-items-center">
//                   <Col xs="8">
//                     <h6 className="mb-0">เปิดบิล</h6>
//                   </Col>
//                 </Row>
//               </CardHeader>
//               <CardBody>
//                 <Form>
//                   <h6 className="heading-small text-muted mb-4">
//                     ข้อมูลส่วนหัว
//                   </h6>
//                   <Row>
//                     <Col lg="6">
//                       <FormGroup>
//                         <label className="form-control-label d-block">
//                           ลูกค้า
//                         </label>
//                         <Input
//                           className="form-control-alternative"
//                           type="text"
//                           name="customerName"
//                           value={
//                             form.customerCode
//                               ? `(${form.customerCode}) - ${form.customerName}`
//                               : ""
//                           }
//                           readOnly
//                           disabled
//                         />
//                       </FormGroup>
//                     </Col>

//                     <Col lg="6">
//                       <FormGroup>
//                         <label className="form-control-label d-block">
//                           แพ็คเกจ
//                         </label>
//                         <Input
//                           id="serviceSelect"
//                           className="form-control-alternative"
//                           type="select"
//                           name="serviceId"
//                           value={form.serviceId}
//                           onChange={onChange}
//                           required
//                           disabled={Boolean(selectedPkg?.svId)}
//                         >
//                           <option value="">-- เลือก --</option>
//                           {serviceOptions.map((o) => (
//                             <option key={o.value} value={o.value}>
//                               {o.label}
//                             </option>
//                           ))}
//                         </Input>
//                       </FormGroup>
//                     </Col>
//                   </Row>

//                   {/* วันที่ */}
//                   <Row>
//                     <Col lg="6" md="6">
//                       <FormGroup className="mb-0">
//                         <label className="form-control-label">
//                           วันที่รับผ้า
//                         </label>
//                         <Input
//                           type="date"
//                           className="form-control-alternative"
//                           value={receiveDate}
//                           onChange={(e) => setReceiveDate(e.target.value)}
//                         />
//                       </FormGroup>
//                     </Col>
//                     <Col lg="6" md="6">
//                       <FormGroup className="mb-0">
//                         <label className="form-control-label">
//                           วันที่ส่งผ้า
//                         </label>
//                         <Input
//                           type="date"
//                           className="form-control-alternative"
//                           value={dueDate}
//                           onChange={(e) => setDueDate(e.target.value)}
//                         />
//                       </FormGroup>
//                     </Col>
//                   </Row>

//                   <hr className="my-4" />
//                   <h6 className="heading-small text-muted mb-4">รายละเอียด</h6>

//                   <Row>
//                     <Col lg="4">
//                       <FormGroup>
//                         <label className="form-control-label">สินค้า</label>
//                         <Input
//                           className="form-control-alternative"
//                           type="select"
//                           name="detailName"
//                           value={detailName}
//                           onChange={handleSelectProduct}
//                         >
//                           <option value="">-- เลือก --</option>
//                           {cusTypeOptions.map((o) => (
//                             <option key={o.value} value={o.value}>
//                               {o.label}
//                             </option>
//                           ))}
//                         </Input>
//                       </FormGroup>
//                     </Col>

//                     <Col lg="2">
//                       <FormGroup>
//                         <label className="form-control-label">จำนวน</label>
//                         <Input
//                           className="form-control-alternative"
//                           type="number"
//                           min="1"
//                           value={detailQty}
//                           onChange={(e) => setDetailQty(e.target.value)}
//                         />
//                       </FormGroup>
//                     </Col>

//                     <Col lg="2">
//                       <FormGroup>
//                         <label className="form-control-label">หน่วย</label>
//                         <Input
//                           className="form-control-alternative"
//                           type="text"
//                           value={serviceUnit || ""}
//                           readOnly
//                           disabled
//                         />
//                       </FormGroup>
//                     </Col>

//                     <Col lg="2">
//                       <FormGroup>
//                         <label className="form-control-label">
//                           ค่าบริการ/ชิ้น
//                         </label>
//                         <Input
//                           className="form-control-alternative"
//                           type="text"
//                           value={detailPrice}
//                           readOnly
//                           disabled
//                         />
//                       </FormGroup>
//                     </Col>

//                     <Col lg="2">
//                       <FormGroup className="mb-0">
//                         <Label className="invisible">offset</Label>
//                         <Button
//                           color="info"
//                           onClick={handleAddDetail}
//                           className="w-100"
//                         >
//                           เพิ่ม
//                         </Button>
//                       </FormGroup>
//                     </Col>
//                   </Row>

//                   <hr className="my-4" />
//                   <Row>
//                     <Col lg="12">
//                       <div className="table-responsive">
//                         <Table
//                           responsive
//                           hover
//                           borderless
//                           className="table table-modern mb-0 order-detail-table"
//                         >
//                           <thead className="thead-dark">
//                             <tr>
//                               <th
//                                 className="text-center"
//                                 style={{ width: "50%" }}
//                               >
//                                 สินค้า
//                               </th>
//                               <th
//                                 className="text-center"
//                                 style={{ width: "15%" }}
//                               >
//                                 จำนวน
//                               </th>
//                               <th
//                                 className="text-center"
//                                 style={{ width: "15%" }}
//                               >
//                                 หน่วย
//                               </th>
//                               <th
//                                 className="text-center"
//                                 style={{ width: "15%" }}
//                               >
//                                 ค่าบริการ/ชิ้น
//                               </th>
//                               <th
//                                 className="text-center"
//                                 style={{ width: "20%" }}
//                               ></th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {details.length === 0 ? (
//                               <tr>
//                                 <td
//                                   colSpan={4}
//                                   className="text-center text-muted"
//                                 >
//                                   ยังไม่มีรายการ
//                                 </td>
//                               </tr>
//                             ) : (
//                               details.map((d) => (
//                                 <tr key={d.id}>
//                                   <td data-th="สินค้า">
//                                     <Input
//                                       type="text"
//                                       value={d.productLabel || ""}
//                                       readOnly
//                                       className="form-control-alternative w-100 text-center"
//                                     />
//                                   </td>
//                                   <td data-th="รหัสสินค้า">
//                                     <Input
//                                       type="number"
//                                       min="0"
//                                       value={d.qty}
//                                       onChange={(e) =>
//                                         handleChangeDetailQty(
//                                           d.id,
//                                           e.target.value
//                                         )
//                                       }
//                                       className="form-control-alternative w-100 text-center"
//                                     />
//                                   </td>
//                                   <td data-th="จำนวน">
//                                     <Input
//                                       type="text"
//                                       value={d.unit || serviceUnit || ""}
//                                       readOnly
//                                       className="form-control-alternative w-100 text-center"
//                                     />
//                                   </td>
//                                   <td data-th="ค่าบริการ/ชิ้น">
//                                     <Input
//                                       type="text"
//                                       value={Number(d.price).toFixed(2)}
//                                       readOnly
//                                       disabled
//                                       className="form-control-alternative w-100 text-center"
//                                     />
//                                   </td>
//                                   <td className="text-right">
//                                     <Button
//                                       color="danger"
//                                       onClick={() => handleRemoveDetail(d.id)}
//                                     >
//                                       ลบ
//                                     </Button>
//                                   </td>
//                                 </tr>
//                               ))
//                             )}
//                           </tbody>
//                         </Table>
//                       </div>
//                     </Col>
//                   </Row>
//                 </Form>
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>
//       </Container>

//       <ModalFooter>
//         <Button color="secondary" onClick={handleCancelAddRecordOrder}>
//           ยกเลิก
//         </Button>
//         <Button color="primary" type="button" onClick={handleSaveBill}>
//           เปิดบิล
//         </Button>
//       </ModalFooter>
//     </>
//   );
// };

// export default AddRecordOrder;

import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { useSessionStore } from "../../stores/sessionStore";
import { api } from "../../config/middleware";
import {
  API_GETSERVICEWITHPRODUCTS,
  API_CREATEBILL,
  API_GETPRODUCTS,
  API_ADDPRODUCT,
} from "../../config/api";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  ModalFooter,
  Label,
  Table,
} from "reactstrap";
import Header from "components/Headers/Header";
import Swal from "sweetalert2";

const AddRecordOrder = () => {
  const sa = {
    info: (text, title = "แจ้งเตือน") =>
      Swal.fire({ icon: "info", title, text, confirmButtonText: "ตกลง" }),
    success: (text, title = "สำเร็จ") =>
      Swal.fire({
        icon: "success",
        title,
        text,
        showConfirmButton: false,
        timer: 2000,
      }),
    error: (text, title = "เกิดข้อผิดพลาด") =>
      Swal.fire({ icon: "error", title, text, confirmButtonText: "ปิด" }),
  };

  const navigate = useNavigate();
  const location = useLocation();

  // ---------- session ----------
  const { user } = useAuth(); // (unused but keep)
  const orgId = useSessionStore((s) => s.profile?.orgId);
  const tnId = useSessionStore((s) => s.profile?.tnId);
  const brId = useSessionStore((s) => s.profile?.brId);

  // ---------- รับ state จากหน้าก่อนหน้า ----------
  const navState = location.state || {};
  const customerFromState = navState.customer || null;
  const selectedPkg = navState.package || null;

  const customerDisplay = customerFromState
    ? `(${customerFromState.code}) - ${customerFromState.name}`
    : "";

  // ---------- form ----------
  const [form, setForm] = useState({
    serviceId: selectedPkg?.svId ? String(selectedPkg.svId) : "",
    customerCode: customerFromState?.code || "",
  });

  // วันที่
  const [receiveDate, setReceiveDate] = useState(""); // BRECEIVE
  const [dueDate, setDueDate] = useState(""); // BDUEDATE

  // ---------- service detail ----------
  const [services, setServices] = useState([]);
  const [loadingServices, setLoadingServices] = useState(false);
  const [serviceError, setServiceError] = useState("");

  // ---------- products ----------
  const [products, setProducts] = useState([]); // สินค้าจาก API_GETPRODUCTS (cmcode ก่อน ถ้าไม่มีค่อย ORG)
  const [loadingProducts, setLoadingProducts] = useState(false);

  // ---------- responsive ----------
  const [isSmall, setIsSmall] = useState(window.innerWidth < 768);
  useEffect(() => {
    const onResize = () => setIsSmall(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // โหลดบริการ (เพื่อเอา svQty/svUnit/svPrice ล่าสุดไว้เช็คคงเหลือ)
  useEffect(() => {
    if (!orgId) return;
    const fetchServices = async () => {
      setLoadingServices(true);
      setServiceError("");
      try {
        const res = await api.get(API_GETSERVICEWITHPRODUCTS, {
          params: { ORGID: orgId },
        });
        const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
        setServices(arr);
      } catch (e) {
        console.error("API_GETSERVICEWITHPRODUCTS error:", e);
        setServiceError(
          e?.response?.data?.message || e?.message || "ไม่สามารถโหลดบริการได้",
        );
      } finally {
        setLoadingServices(false);
      }
    };
    fetchServices();
  }, [orgId]);

  // โหลดสินค้า: ส่ง CMCODE=cmcode ก่อน ถ้าไม่มีค่อยใช้ CMCODE=ORG
  useEffect(() => {
    if (!orgId) return;

    const fetchProducts = async () => {
      setLoadingProducts(true);
      try {
        const cmcode = (form.customerCode || "").trim();

        // 1) สินค้าลูกค้า
        let res = await api.get(API_GETPRODUCTS, {
          params: { ORGID: orgId, CMCODE: cmcode || "cmcode" },
        });
        let arr = Array.isArray(res?.data?.data) ? res.data.data : [];

        // 2) fallback สินค้าระบบ
        if (!arr || arr.length === 0) {
          res = await api.get(API_GETPRODUCTS, {
            params: { ORGID: orgId, CMCODE: "ORG" },
          });
          arr = Array.isArray(res?.data?.data) ? res.data.data : [];
        }

        setProducts(arr);
      } catch (e) {
        console.error("API_GETPRODUCTS error:", e);
        sa.error(
          e?.response?.data?.message || e?.message || "ไม่สามารถโหลดสินค้าได้",
        );
        setProducts([]);
      } finally {
        setLoadingProducts(false);
      }
    };

    fetchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId, form.customerCode]);

  // service ปัจจุบันที่เลือก (ถ้า services ยังไม่มา จะ fallback selectedPkg)
  const currentService = useMemo(() => {
    const fromApi = services.find(
      (s) => String(s.svId) === String(form.serviceId),
    );
    return fromApi || selectedPkg || null;
  }, [services, form.serviceId, selectedPkg]);

  const isPieceBased = currentService?.svType === "รายชิ้น";
  const pkgPrice = Number(currentService?.svPrice || 0);
  const pkgQty = Number(currentService?.svQty || 0);
  const currentUnit = (currentService?.svUnit || "").trim();

  const isQtyLimitedUnit = useMemo(() => {
    return currentUnit === "ชุด" || currentUnit === "ตัว/ชิ้น";
  }, [currentUnit]);

  const isKgUnit = useMemo(() => currentUnit === "กิโลกรัม", [currentUnit]);

  // ---------- ฟอร์มเพิ่มรายการแบบ API (ด้านบน) ----------
  const [detailProductId, setDetailProductId] = useState("");
  const [detailQty, setDetailQty] = useState("");
  const [detailPrice, setDetailPrice] = useState("");
  const [detailWeight, setDetailWeight] = useState("");

  // ---------- รายการทั้งหมด (api + custom) ----------
  const [details, setDetails] = useState([]);

  const totalQty = useMemo(() => {
    return details.reduce((sum, d) => sum + Number(d.qty || 0), 0);
  }, [details]);

  const totalWeight = useMemo(() => {
    return details.reduce(
      (sum, d) => sum + Number(d.weight || 0) * Number(d.qty || 0),
      0,
    );
  }, [details]);

  const exceedQtyAlert = (nextQty) => {
    sa.info(
      `จำนวนรวม ${nextQty} เกินจำนวนคงเหลือ ${pkgQty} ${currentUnit || ""}`,
    );
  };

  const exceedWeightAlert = (nextWeight) => {
    sa.info(
      `น้ำหนักรวม ${Number(nextWeight || 0).toFixed(2)} เกินจำนวนคงเหลือ ${Number(
        pkgQty || 0,
      ).toFixed(2)} ${currentUnit || ""}`,
    );
  };

  // เลือกสินค้า (ฟอร์มเพิ่มรายการแบบ API) -> เติมราคา/น้ำหนัก
  const handleSelectProduct = (e) => {
    const val = e.target.value;
    setDetailProductId(val);

    const found = products.find((p) => String(p.pdId) === String(val));
    if (found) {
      setDetailPrice(Number(found.pdPrice || 0).toFixed(2));
      setDetailWeight(Number(found.pdWeight || 0).toFixed(2));
    } else {
      setDetailPrice("");
      setDetailWeight("");
    }
  };

  // เพิ่มรายการจาก API (ด้านบน)
  const handleAddDetail = () => {
    const qty = Number(detailQty);
    const price = Number(detailPrice);

    if (!detailProductId) return sa.info("กรุณาเลือกสินค้า");
    if (!qty || qty <= 0) return sa.info("กรุณากรอกจำนวนให้ถูกต้อง");
    if (!price || price <= 0) return sa.info("ราคาสินค้าไม่ถูกต้อง");

    // ✅ คุมจำนวน (ชุด/ตัว-ชิ้น)
    if (isQtyLimitedUnit && currentService) {
      const nextTotalQty = Number(totalQty) + qty;
      if (nextTotalQty > pkgQty) {
        exceedQtyAlert(nextTotalQty);
        return;
      }
    }

    // ✅ คุมน้ำหนัก (กิโลกรัม)
    if (isKgUnit && currentService) {
      const addWeight = Number(detailWeight || 0) * qty;
      const nextTotalWeight = Number(totalWeight) + addWeight;
      if (nextTotalWeight > pkgQty) {
        exceedWeightAlert(nextTotalWeight);
        return;
      }
    }

    const product = products.find(
      (p) => String(p.pdId) === String(detailProductId),
    );

    setDetails((prev) => [
      ...prev,
      {
        id: Date.now(),
        type: "api",
        pdId: product?.pdId,
        pdCode: product?.pdCode,
        productLabel: product?.pdName || "",
        qty,
        price: Number(product?.pdPrice || 0),
        weight: Number(product?.pdWeight || 0),
      },
    ]);

    setDetailProductId("");
    setDetailQty("");
    setDetailPrice("");
    setDetailWeight("");
  };

  // เพิ่มแถวกรอกเอง
  const handleAddCustomRow = () => {
    setDetails((prev) => [
      ...prev,
      {
        id: Date.now() + Math.random(),
        type: "custom",
        productName: "",
        qty: "",
        price: "",
        weight: "",
      },
    ]);
  };

  const handleRemoveRow = (id) => {
    setDetails((prev) => prev.filter((r) => r.id !== id));
  };

  // เปลี่ยนค่าในแถว
  const handleChangeRow = (id, key, value) => {
    // --- คุม qty ---
    if (key === "qty") {
      if (value === "") {
        setDetails((prev) =>
          prev.map((r) => (r.id === id ? { ...r, qty: "" } : r)),
        );
        return;
      }

      const nextQty = Number(value);
      if (isNaN(nextQty) || nextQty < 0) return;

      // ✅ คุมจำนวน (ชุด/ตัว-ชิ้น)
      if (isQtyLimitedUnit && currentService) {
        const currentRow = details.find((r) => r.id === id);
        const oldQty = Number(currentRow?.qty || 0);
        const nextTotalQty = Number(totalQty) - oldQty + nextQty;

        if (nextTotalQty > pkgQty) {
          exceedQtyAlert(nextTotalQty);
          return;
        }
      }

      // ✅ คุมน้ำหนักรวม (กิโลกรัม)
      if (isKgUnit && currentService) {
        const currentRow = details.find((r) => r.id === id);
        const oldQty = Number(currentRow?.qty || 0);
        const rowWeightEach = Number(currentRow?.weight || 0);

        const oldRowTotalW = rowWeightEach * oldQty;
        const newRowTotalW = rowWeightEach * nextQty;

        const nextTotalWeight =
          Number(totalWeight) - oldRowTotalW + newRowTotalW;

        if (nextTotalWeight > pkgQty) {
          exceedWeightAlert(nextTotalWeight);
          return;
        }
      }

      setDetails((prev) =>
        prev.map((r) => (r.id === id ? { ...r, qty: nextQty } : r)),
      );
      return;
    }

    // --- คุม weight (เฉพาะ custom) ---
    if (key === "weight") {
      const nextW = value === "" ? "" : Number(value);
      if (value !== "" && (isNaN(nextW) || nextW < 0)) return;

      if (isKgUnit && currentService) {
        const currentRow = details.find((r) => r.id === id);
        const rowQty = Number(currentRow?.qty || 0);
        const oldW = Number(currentRow?.weight || 0);

        const oldRowTotalW = oldW * rowQty;
        const newRowTotalW = Number(nextW || 0) * rowQty;

        const nextTotalWeight =
          Number(totalWeight) - oldRowTotalW + newRowTotalW;

        if (nextTotalWeight > pkgQty) {
          exceedWeightAlert(nextTotalWeight);
          return;
        }
      }

      setDetails((prev) =>
        prev.map((r) => (r.id === id ? { ...r, weight: value } : r)),
      );
      return;
    }

    // productName / price / อื่นๆ
    setDetails((prev) =>
      prev.map((r) => (r.id === id ? { ...r, [key]: value } : r)),
    );
  };

  const handleCancelAddRecordOrder = () => {
    navigate("/order-orgs");
  };

  const handleSaveBill = async () => {
    const normalize = (v) => String(v ?? "").trim();

    // ✅ ระบบคุณมีเคส statustext ERROR!!! แต่ message บันทึกสำเร็จ!
    const isRealSuccess = (resOrData) => {
      const data = resOrData?.data ? resOrData.data : resOrData;

      const st = normalize(data?.statustext ?? data?.statusText).toUpperCase();
      const msg = normalize(data?.message);

      if (st.includes("SUCCESS")) return true;
      if (msg.includes("บันทึกสำเร็จ") || msg.includes("สำเร็จ")) return true;

      return false;
    };

    // ✅ helper: ดึง array สินค้าจาก API_GETPRODUCTS
    const extractProducts = (res) => {
      const arr = Array.isArray(res?.data?.data) ? res.data.data : [];
      return arr;
    };

    try {
      // ---------- validate พื้นฐาน ----------
      if (tnId == null || orgId == null || brId == null) {
        return sa.error("ไม่พบข้อมูลสาขาหรือองค์กร (TNID/ORGID/BRID)");
      }

      if (!form.customerCode) return sa.info("กรุณาเลือกลูกค้า");
      if (!form.serviceId) return sa.info("กรุณาเลือกแพ็คเกจ/บริการ");
      if (!receiveDate || !dueDate)
        return sa.info("กรุณาเลือกวันที่รับผ้าและวันที่ส่งผ้า");

      // ---------- แยกแถวสินค้า: API / กรอกเอง ----------
      const apiRows = (details || []).filter((d) => !!d?.pdId);

      const customRows = (details || []).filter((d) => {
        const name = String(d?.productName || d?.productLabel || "").trim();
        return !d?.pdId && name.length > 0;
      });

      if (apiRows.length === 0 && customRows.length === 0) {
        return sa.info("กรุณาเพิ่มรายการสินค้าอย่างน้อย 1 รายการ");
      }

      // ---------- validate แถวกรอกเอง ----------
      for (const r of customRows) {
        const name = String(r?.productName || r?.productLabel || "").trim();
        const qty = Number(r?.qty || 0);
        const price = Number(r?.price || 0);
        const weight = Number(r?.weight || 0);

        if (!name) return sa.info("กรุณากรอกชื่อสินค้า (กรอกเอง)");
        if (!qty || qty <= 0)
          return sa.info(`กรุณากรอกจำนวนให้ถูกต้อง (${name})`);
        if (!price || price <= 0)
          return sa.info(`กรุณากรอกราคาให้ถูกต้อง (${name})`);
        if (weight < 0) return sa.info(`กรุณากรอกน้ำหนักให้ถูกต้อง (${name})`);
      }

      // ---------- เช็คคงเหลือ (ชุด/ตัว/ชิ้น/กิโลกรัม) ----------
      const totalQtyUsed =
        apiRows.reduce((s, d) => s + Number(d.qty || 0), 0) +
        customRows.reduce((s, d) => s + Number(d.qty || 0), 0);

      const totalWeightUsed =
        apiRows.reduce(
          (sum, d) => sum + Number(d.weight || 0) * Number(d.qty || 0),
          0,
        ) +
        customRows.reduce(
          (sum, d) => sum + Number(d.weight || 0) * Number(d.qty || 0),
          0,
        );

      if (currentService) {
        const unit = String(currentService?.svUnit || "").trim();
        const remain = Number(currentService?.svQty || 0);

        if ((unit === "ชุด" || unit === "ตัว/ชิ้น") && remain > 0) {
          if (totalQtyUsed > remain)
            return sa.info(`จำนวนเกินคงเหลือ (${remain} ${unit})`);
        }

        if (unit === "กิโลกรัม" && remain > 0) {
          if (totalWeightUsed > remain) {
            return sa.info(
              `น้ำหนักรวมเกินคงเหลือ (${remain.toFixed(2)} ${unit})`,
            );
          }
        }
      }

      // ---------- 1) สร้างสินค้า (กรอกเอง) ----------
      // เก็บ "ชื่อสินค้า" ไว้ใช้ map ตอน GETPRODUCTS
      const createdCustomByName = []; // [{ name, qty, price, weight }]

      for (const r of customRows) {
        const NAME = String(r?.productName || r?.productLabel || "").trim();
        const PRICE = Number(r?.price || 0);
        const WEIGHT = Number(r?.weight || 0);

        let addRes;
        try {
          addRes = await api.post(API_ADDPRODUCT, {
            ORGID: orgId,
            CMCODE: form.customerCode,
            NAME,
            PRICE,
            WEIGHT,
          });
        } catch (err) {
          console.error(
            "API_ADDPRODUCT axios error:",
            err?.response?.data || err,
          );
          return sa.error(
            err?.response?.data?.message ||
              err?.message ||
              "เพิ่มสินค้ากรอกเองไม่สำเร็จ",
          );
        }

        // ✅ สำคัญ: ถึงแม้ API จะตอบ statustext แปลก ๆ ก็ยังเช็คด้วย message
        if (!isRealSuccess(addRes)) {
          console.error("API_ADDPRODUCT not success:", addRes?.data);
          return sa.error(
            addRes?.data?.message || "เพิ่มสินค้ากรอกเองไม่สำเร็จ",
          );
        }

        createdCustomByName.push({
          name: NAME,
          qty: Number(r?.qty || 0),
          price: PRICE,
          weight: WEIGHT,
        });
      }

      // ---------- 2) ยิง API_GETPRODUCTS เพื่อดึงสินค้าล่าสุด แล้วเอา pdId มาใช้เปิดบิล ----------
      let latestCustomerProducts = [];
      try {
        const prRes = await api.get(API_GETPRODUCTS, {
          params: { ORGID: orgId, CMCODE: form.customerCode },
        });
        latestCustomerProducts = extractProducts(prRes);
        // อัปเดต state ไว้ด้วย (ไม่จำเป็นแต่ดี)
        setProducts(latestCustomerProducts);
      } catch (e) {
        console.error(
          "API_GETPRODUCTS after add custom error:",
          e?.response?.data || e,
        );
        return sa.error(
          e?.response?.data?.message ||
            e?.message ||
            "โหลดสินค้าล่าสุดไม่สำเร็จ",
        );
      }

      // ---------- 3) เตรียม ITEMS สำหรับเปิดบิล ----------
      // 3.1 items จากสินค้าที่เลือกจาก API เดิม
      const apiItems = apiRows
        .map((d) => ({
          pdId: d.pdId,
          bdQty: Number(d.qty || 0),
          pdPrice: Number(d.price || 0),
          weight: Number(d.weight || 0),
        }))
        .filter((it) => it.pdId && it.bdQty > 0);

      // 3.2 items จาก "กรอกเอง" -> map ชื่อสินค้าไปหา pdId จาก GETPRODUCTS ล่าสุด
      const customItems = createdCustomByName
        .map((c) => {
          const found = latestCustomerProducts.find(
            (p) =>
              normalize(p?.pdName).toLowerCase() ===
              normalize(c.name).toLowerCase(),
          );

          return {
            pdId: found?.pdId,
            bdQty: Number(c.qty || 0),
            pdPrice: Number(c.price || 0),
            weight: Number(c.weight || 0),
            _name: c.name, // debug
          };
        })
        .filter((it) => it.pdId && it.bdQty > 0);

      // ✅ ถ้า map ชื่อแล้วไม่เจอ ให้แจ้งชัด ๆ
      const notFoundNames = createdCustomByName
        .filter((c) => {
          const ok = latestCustomerProducts.some(
            (p) =>
              normalize(p?.pdName).toLowerCase() ===
              normalize(c.name).toLowerCase(),
          );
          return !ok;
        })
        .map((x) => x.name);

      if (notFoundNames.length > 0) {
        console.error(
          "Custom product name not found in GETPRODUCTS:",
          notFoundNames,
        );
        return sa.error(
          `เพิ่มสินค้าแล้ว แต่หา pdId ไม่เจอจากรายการสินค้า: ${notFoundNames.join(", ")}`,
        );
      }

      // ITEMS ส่งไป backend ต้องตัด weight ออก
      const ITEMS = [...apiItems, ...customItems].map(
        ({ weight, _name, ...rest }) => rest,
      );

      if (ITEMS.length === 0) {
        return sa.info("กรุณาเพิ่มรายการสินค้าอย่างน้อย 1 รายการ");
      }

      // ---------- TOTALPDWEIGHT ----------
      const totalPdWeight = [...apiItems, ...customItems].reduce(
        (sum, d) => sum + Number(d.weight || 0) * Number(d.bdQty || 0),
        0,
      );

      // ---------- 4) ยิง API_CREATEBILL ----------
      const payload = {
        TNID: tnId,
        ORGID: orgId,
        BRID: brId,
        CMCODE: form.customerCode,
        SVID: Number(form.serviceId),
        BRECEIVE: receiveDate,
        BDUEDATE: dueDate,
        DISCOUNT: 0,
        VAT: 0,
        TOTALPDWEIGHT: Number(totalPdWeight || 0).toFixed(2),
        ITEMS,
      };

      console.log("ABOUT TO CREATEBILL payload:", payload);

      const res = await api.post(API_CREATEBILL, payload);

      if (!isRealSuccess(res)) {
        console.error("API_CREATEBILL error:", res?.data);
        return sa.error(res?.data?.message || "เปิดบิลไม่สำเร็จ");
      }

      await sa.success(res?.data?.message || "เปิดบิลสำเร็จ");
      navigate("/order-bill-org");
    } catch (e) {
      console.error("handleSaveBill exception:", e);

      const data = e?.response?.data;
      if (isRealSuccess(data)) {
        await sa.success(data?.message || "เปิดบิลสำเร็จ");
        navigate("/order-bill-org");
        return;
      }

      sa.error(data?.message || e?.message || "เกิดข้อผิดพลาด");
    }
  };

  return (
    <>
      {/* ✅ CSS desktop/tablet table */}
      <style>{`
        .zi-table-wrap{
          background:#fff;
          border-radius:10px;
          border:1px solid rgba(0,0,0,.06);
          overflow:hidden;
        }
        .zi-table{ margin:0; }
        .zi-table thead th{
          background:#f7fafc;
          color:#0f172a;
          font-weight:700;
          font-size:14px;
          border-bottom:1px solid rgba(0,0,0,.06);
          padding:14px 16px;
          white-space:nowrap;
        }
        .zi-table tbody td{
          padding:14px 16px;
          border-top:1px solid rgba(0,0,0,.06);
          vertical-align:middle;
          font-size:14px;
          color:#0f172a;
        }
        .zi-table tbody tr:hover{ background:#f9fbff; }
        .fw-600{ font-weight:600; }
      `}</style>

      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col xs="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h6 className="mb-0">เปิดบิล</h6>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody>
                <Form onSubmit={(e) => e.preventDefault()}>
                  <h6 className="heading-small text-muted mb-4">
                    ข้อมูลส่วนหัว
                  </h6>

                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label d-block">
                          ลูกค้า
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="text"
                          value={customerDisplay}
                          readOnly
                          disabled
                        />
                      </FormGroup>
                    </Col>

                    <Col lg="6">
                      <FormGroup>
                        <label className="form-control-label d-block">
                          แพ็คเกจ
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="text"
                          value={
                            selectedPkg
                              ? `${
                                  selectedPkg.svName || selectedPkg.name || ""
                                }`
                              : ""
                          }
                          readOnly
                          disabled
                        />
                        {/* เก็บค่า serviceId ไว้ใช้งาน */}
                        <Input type="hidden" value={form.serviceId} />
                        {loadingServices && (
                          <div
                            className="text-muted mt-1"
                            style={{ fontSize: 12 }}
                          >
                            กำลังโหลดรายละเอียดแพ็คเกจ...
                          </div>
                        )}
                        {!!serviceError && (
                          <div
                            className="text-danger mt-1"
                            style={{ fontSize: 12 }}
                          >
                            {serviceError}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg="6" md="6">
                      <FormGroup className="mb-0">
                        <label className="form-control-label">
                          วันที่รับผ้า
                        </label>
                        <Input
                          type="date"
                          className="form-control-alternative"
                          value={receiveDate}
                          onChange={(e) => setReceiveDate(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="6" md="6">
                      <FormGroup className="mb-0">
                        <label className="form-control-label">
                          วันที่ส่งผ้า
                        </label>
                        <Input
                          type="date"
                          className="form-control-alternative"
                          value={dueDate}
                          onChange={(e) => setDueDate(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <hr className="my-4" />
                  <h6 className="heading-small text-muted mb-4">รายละเอียด</h6>

                  {/* ฟอร์มเพิ่มรายการแบบ API */}
                  <Row>
                    <Col lg="3">
                      <FormGroup>
                        <label className="form-control-label">สินค้า</label>
                        <Input
                          className="form-control-alternative"
                          type="select"
                          value={detailProductId}
                          onChange={handleSelectProduct}
                          disabled={loadingProducts || products.length === 0}
                        >
                          <option value="">
                            {loadingProducts
                              ? "-- กำลังโหลดสินค้า --"
                              : products.length === 0
                                ? "-- ไม่มีสินค้า --"
                                : "-- เลือก --"}
                          </option>
                          {products.map((p) => (
                            <option key={p.pdId} value={p.pdId}>
                              ({p.pdCode}) {p.pdName}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col lg="3">
                      <FormGroup>
                        <label className="form-control-label">จำนวนผ้า</label>
                        <Input
                          className="form-control-alternative"
                          type="number"
                          min="1"
                          value={detailQty}
                          onChange={(e) => setDetailQty(e.target.value)}
                        />
                      </FormGroup>
                    </Col>

                    <Col lg="2">
                      <FormGroup>
                        <label className="form-control-label">
                          ค่าบริการต่อชิ้น (บาท)
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="text"
                          value={detailPrice}
                          readOnly
                          disabled
                        />
                      </FormGroup>
                    </Col>

                    <Col lg="2">
                      <FormGroup>
                        <label className="form-control-label">
                          น้ำหนักต่อชิ้น (กิโลกรัม)
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="text"
                          value={detailWeight}
                          readOnly
                          disabled
                        />
                      </FormGroup>
                    </Col>

                    <Col lg="2">
                      <FormGroup className="mb-0">
                        <Label className="invisible">offset</Label>
                        <Button
                          color="info"
                          onClick={handleAddDetail}
                          className="w-100"
                          type="button"
                        >
                          เพิ่ม
                        </Button>
                      </FormGroup>
                    </Col>
                  </Row>

                  <hr className="my-4" />

                  {/* ปุ่มเพิ่มแถวกรอกเอง */}
                  {/* <div className="d-flex justify-content-end align-items-center mb-2">
                    <Button
                      color="info"
                      type="button"
                      onClick={handleAddCustomRow}
                    >
                      + เพิ่มสินค้า (กรอกเอง)
                    </Button>
                  </div> */}

                  {/* ตารางรายการ */}
                  <Row>
                    <Col lg="12">
                      {isSmall ? (
                        <div className="table-responsive">
                          <Table
                            responsive
                            hover
                            borderless
                            className="table table-modern mb-0"
                          >
                            <thead className="thead-dark">
                              <tr>
                                <th
                                  className="text-center"
                                  style={{ width: "30%" }}
                                >
                                  สินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  จำนวนผ้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  ค่าบริการต่อชิ้น (บาท)
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  น้ำหนักต่อชิ้น (กิโลกรัม)
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  น้ำหนักรวม (กิโลกรัม)
                                </th>
                                <th
                                  className="text-end"
                                  style={{ width: "10%" }}
                                ></th>
                              </tr>
                            </thead>

                            <tbody>
                              {details.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan={6}
                                    className="text-center text-muted py-4"
                                  >
                                    ยังไม่มีรายการ
                                  </td>
                                </tr>
                              ) : (
                                details.map((d) => {
                                  const rowTotalWeight =
                                    Number(d.weight || 0) * Number(d.qty || 0);

                                  return (
                                    <tr key={d.id}>
                                      <td data-th="สินค้า">
                                        {d.type === "custom" ? (
                                          <Input
                                            className="form-control-alternative"
                                            type="text"
                                            placeholder="เช่น เสื้อยืด / กางเกง / ผ้าห่ม"
                                            value={d.productName || ""}
                                            onChange={(e) =>
                                              handleChangeRow(
                                                d.id,
                                                "productName",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        ) : (
                                          d.productLabel || ""
                                        )}
                                      </td>

                                      <td data-th="จำนวนผ้า">
                                        <Input
                                          className="form-control-alternative"
                                          type="number"
                                          min="0"
                                          value={d.qty}
                                          onChange={(e) =>
                                            handleChangeRow(
                                              d.id,
                                              "qty",
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </td>

                                      <td data-th="ค่าบริการต่อชิ้น (บาท)">
                                        {d.type === "custom" ? (
                                          <Input
                                            className="form-control-alternative"
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            value={d.price}
                                            onChange={(e) =>
                                              handleChangeRow(
                                                d.id,
                                                "price",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        ) : (
                                          Number(d.price || 0).toFixed(2)
                                        )}
                                      </td>

                                      <td data-th="น้ำหนักต่อชิ้น (กิโลกรัม)">
                                        {d.type === "custom" ? (
                                          <Input
                                            className="form-control-alternative"
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            value={d.weight}
                                            onChange={(e) =>
                                              handleChangeRow(
                                                d.id,
                                                "weight",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        ) : (
                                          Number(d.weight || 0).toFixed(2)
                                        )}
                                      </td>

                                      <td data-th="น้ำหนักรวม (กิโลกรัม)">
                                        {Number(rowTotalWeight || 0).toFixed(2)}
                                      </td>

                                      <td className="text-end">
                                        <Button
                                          color="danger"
                                          size="sm"
                                          onClick={() => handleRemoveRow(d.id)}
                                          type="button"
                                        >
                                          ลบ
                                        </Button>
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </Table>
                        </div>
                      ) : (
                        <div className="zi-table-wrap">
                          <Table responsive hover className="zi-table mb-0">
                            <thead>
                              <tr>
                                <th
                                  className="text-center"
                                  style={{ width: "30%" }}
                                >
                                  สินค้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  จำนวนผ้า
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  ค่าบริการต่อชิ้น (บาท)
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  น้ำหนักต่อชิ้น (กิโลกรัม)
                                </th>
                                <th
                                  className="text-center"
                                  style={{ width: "15%" }}
                                >
                                  น้ำหนักรวม (กิโลกรัม)
                                </th>
                                <th
                                  className="text-end"
                                  style={{ width: "10%" }}
                                ></th>
                              </tr>
                            </thead>

                            <tbody>
                              {details.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan={6}
                                    className="text-center text-muted py-4"
                                  >
                                    ยังไม่มีรายการ
                                  </td>
                                </tr>
                              ) : (
                                details.map((d) => {
                                  const rowTotalWeight =
                                    Number(d.weight || 0) * Number(d.qty || 0);

                                  return (
                                    <tr key={d.id}>
                                      <td>
                                        {d.type === "custom" ? (
                                          <Input
                                            type="text"
                                            placeholder="เช่น เสื้อยืด / กางเกง / ผ้าห่ม"
                                            value={d.productName || ""}
                                            onChange={(e) =>
                                              handleChangeRow(
                                                d.id,
                                                "productName",
                                                e.target.value,
                                              )
                                            }
                                            className="form-control-alternative"
                                          />
                                        ) : (
                                          <Input
                                            type="text"
                                            value={d.productLabel || ""}
                                            readOnly
                                            className="form-control-alternative"
                                          />
                                        )}
                                      </td>

                                      <td className="text-center">
                                        <Input
                                          type="number"
                                          min="0"
                                          value={d.qty}
                                          onChange={(e) =>
                                            handleChangeRow(
                                              d.id,
                                              "qty",
                                              e.target.value,
                                            )
                                          }
                                          className="form-control-alternative"
                                          style={{
                                            maxWidth: 140,
                                            margin: "0 auto",
                                            textAlign: "center",
                                          }}
                                        />
                                      </td>

                                      <td className="text-center">
                                        {d.type === "custom" ? (
                                          <Input
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            value={d.price}
                                            onChange={(e) =>
                                              handleChangeRow(
                                                d.id,
                                                "price",
                                                e.target.value,
                                              )
                                            }
                                            className="form-control-alternative"
                                            style={{
                                              maxWidth: 140,
                                              margin: "0 auto",
                                              textAlign: "center",
                                            }}
                                          />
                                        ) : (
                                          <Input
                                            type="text"
                                            value={Number(d.price || 0).toFixed(
                                              2,
                                            )}
                                            readOnly
                                            className="form-control-alternative"
                                            style={{
                                              maxWidth: 140,
                                              margin: "0 auto",
                                              textAlign: "center",
                                            }}
                                          />
                                        )}
                                      </td>

                                      <td className="text-center">
                                        {d.type === "custom" ? (
                                          <Input
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            value={d.weight}
                                            onChange={(e) =>
                                              handleChangeRow(
                                                d.id,
                                                "weight",
                                                e.target.value,
                                              )
                                            }
                                            className="form-control-alternative"
                                            style={{
                                              maxWidth: 140,
                                              margin: "0 auto",
                                              textAlign: "center",
                                            }}
                                          />
                                        ) : (
                                          <Input
                                            type="text"
                                            value={Number(
                                              d.weight || 0,
                                            ).toFixed(2)}
                                            readOnly
                                            disabled
                                            className="form-control-alternative"
                                            style={{
                                              maxWidth: 140,
                                              margin: "0 auto",
                                              textAlign: "center",
                                            }}
                                          />
                                        )}
                                      </td>

                                      <td className="text-center">
                                        <Input
                                          type="text"
                                          value={Number(
                                            rowTotalWeight || 0,
                                          ).toFixed(2)}
                                          readOnly
                                          disabled
                                          className="form-control-alternative"
                                          style={{
                                            maxWidth: 140,
                                            margin: "0 auto",
                                            textAlign: "center",
                                          }}
                                        />
                                      </td>

                                      <td className="text-end">
                                        <Button
                                          color="danger"
                                          onClick={() => handleRemoveRow(d.id)}
                                          type="button"
                                        >
                                          ลบ
                                        </Button>
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </Table>
                        </div>
                      )}
                    </Col>
                  </Row>

                  {/* Summary */}
                  <Row className="justify-content-end mt-3 mb-2">
                    <Col lg="4" md="6" className="text-right">
                      <div
                        style={{
                          background: "#f5f7fa",
                          padding: "12px 15px",
                          borderRadius: "8px",
                          border: "1px solid #e3e6ef",
                        }}
                      >
                        <div style={{ fontSize: 14, color: "#555" }}>
                          น้ำหนักรวมทั้งหมด
                        </div>
                        <div
                          style={{
                            fontSize: 20,
                            fontWeight: 700,
                            color: "#1f2937",
                            marginBottom: 6,
                          }}
                        >
                          {totalWeight.toFixed(2)} กิโลกรัม
                        </div>

                        {/* โชว์น้ำหนักรวม/คงเหลือ เมื่อมี service */}
                        {currentService && (
                          <div
                            style={{
                              paddingTop: 8,
                              marginTop: 6,
                              fontSize: 14,
                              color: "#0f172a",
                            }}
                          >
                            <div className="d-flex justify-content-between mt-1">
                              <span>จำนวนคงเหลือ</span>
                              <span style={{ fontWeight: 600 }}>
                                {pkgQty.toLocaleString()} {currentUnit}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>

                  {/* ปุ่ม */}
                  <ModalFooter className="px-0">
                    <Button
                      color="secondary"
                      onClick={handleCancelAddRecordOrder}
                      type="button"
                    >
                      ยกเลิก
                    </Button>
                    <Button
                      color="primary"
                      type="button"
                      onClick={handleSaveBill}
                    >
                      เปิดบิล
                    </Button>
                  </ModalFooter>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AddRecordOrder;
